//
// Pad.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./GTLModel";
import "@sas-dvr/ltjs-commons/util/Dimension";

var Pad = createModule("gtl::Pad", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        top: 1,
        left: 1,
        bottom: 1,
        right: 1,
    },
    ,
    ,
    ,
    {
        _create_v: [4],
        _create_s: [4,7],
        _create_nnnn: [4,5,5,5,5],
        _create_oooo: [4,1,1,1,1],
        _create_n: [4,5],
    },
    ,
    ["_create"]
]);
export default Pad;
